import { render, staticRenderFns } from "./InstitutionVoucherRecipients.vue?vue&type=template&id=0561044c&"
import script from "./InstitutionVoucherRecipients.vue?vue&type=script&lang=js&"
export * from "./InstitutionVoucherRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports